import { BALANCE } from '../config/balance';

/** 鞭的横扫区：短暂存在，扇形范围内敌人各受一次打击。 */
export interface Swipe {
  active: boolean;
  x: number;
  y: number;
  /** 中心朝向（弧度）。 */
  dir: number;
  range: number;
  /** 扇形夹角（弧度）。 */
  arc: number;
  life: number;
  maxLife: number;
  damage: number;
  hits: number[];
  /** 处决阈值（敌血比例低于此值即秒杀）；0=不处决。 */
  execute: number;
  knockback: number;
}

export function createSwipe(): Swipe {
  return {
    active: false, x: 0, y: 0, dir: 0,
    range: 100, arc: 1, life: 0, maxLife: 1,
    damage: 0, hits: [], execute: 0, knockback: 0,
  };
}

export function resetSwipe(s: Swipe): void {
  s.hits.length = 0;
}

export function initSwipe(
  s: Swipe,
  x: number,
  y: number,
  dir: number,
  range: number,
  arc: number,
  damage: number,
  execute: number,
): void {
  s.active = true;
  s.x = x;
  s.y = y;
  s.dir = dir;
  s.range = range;
  s.arc = arc;
  s.damage = damage;
  s.execute = execute;
  s.knockback = BALANCE.weapons.whip.knockback;
  s.maxLife = BALANCE.weapons.whip.life;
  s.life = s.maxLife;
}

/** 更新寿命；返回 false 表示到期回收。 */
export function updateSwipe(s: Swipe, dt: number): boolean {
  s.life -= dt;
  return s.life > 0;
}

/** 点是否落在扇形内。 */
export function inSwipe(s: Swipe, ex: number, ey: number): boolean {
  const dx = ex - s.x;
  const dy = ey - s.y;
  const d = Math.hypot(dx, dy);
  if (d > s.range) return false;
  let da = Math.atan2(dy, dx) - s.dir;
  while (da > Math.PI) da -= Math.PI * 2;
  while (da < -Math.PI) da += Math.PI * 2;
  return Math.abs(da) <= s.arc / 2;
}
